"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var TypeStyle = require("typestyle");
var Icons_1 = require("../icons/Icons");
var FocusIndicators_1 = require("../styles/FocusIndicators");
var TabStyles_1 = require("../styles/TabStyles");
var Declarative_1 = require("../utils/Declarative");
var InteractiveDom_1 = require("../utils/InteractiveDom");
var DomWidgets_1 = require("./DomWidgets");
var DynamicThemeComponent_1 = require("./DynamicThemeComponent");
var getStyles = function () {
    return {
        baseDiv: {
            // TFSID: 589174, with flexboxes in safari 9.x if the sibling is 100% then safari can cause the box to shrink in size.
            // Adding flex-shrink: 0 prevents that from happening.
            flexShrink: 0,
            height: Icons_1.CheckBoxIcon.height,
            marginLeft: TabStyles_1.TabStyles.Spacing.DefaultSpace - Icons_1.CheckBoxIcon.padding,
            marginRight: TabStyles_1.TabStyles.Spacing.DefaultSpace - Icons_1.CheckBoxIcon.padding,
            minWidth: Icons_1.CheckBoxIcon.width,
            verticalAlign: 'middle',
            width: Icons_1.CheckBoxIcon.width,
        },
        checkbox: {
            cursor: 'default',
            height: Icons_1.CheckBoxIcon.height,
            margin: 0,
            opacity: 0,
            // Defect 612637 override user agent default `img { vertical-align: baseline }` style
            verticalAlign: 'top',
            width: Icons_1.CheckBoxIcon.width,
        },
        fakeCheckBox: {
            height: Icons_1.CheckBoxIcon.height,
            position: 'absolute',
            // Defect 612637 override user agent default `img { vertical-align: baseline }` style
            verticalAlign: 'top',
            width: Icons_1.CheckBoxIcon.width,
        },
        noLeftMargin: {
            marginLeft: -Icons_1.CheckBoxIcon.padding,
        },
    };
};
function getCheckBoxIcon(props, state) {
    var iconState = {
        checked: props.checked,
        disabled: props.disabled,
        focus: state.focus,
        hover: props.hover || state.hover,
    };
    if (props.indeterminate) {
        return Icons_1.CheckBoxMixedIcon.icon(iconState);
    }
    else {
        return Icons_1.CheckBoxIcon.icon(iconState);
    }
}
var CheckBoxWidget = /** @class */ (function (_super) {
    tslib_1.__extends(CheckBoxWidget, _super);
    function CheckBoxWidget() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {};
        _this.handleFormChange = function (event) {
            // IE bug fix: https://github.com/facebook/react/issues/4457
            if (_this.props.disabled || !_this.props.handleChange) {
                return;
            }
            _this.props.handleChange(event.target.checked);
        };
        _this.handleInputRef = function (ref) {
            _this.inputElement = ref;
            _this.setInputElementsIndeterminateProp();
        };
        _this.handleActive = function (active) {
            _this.setState({ active: active });
        };
        _this.handleFocus = function (focus) {
            _this.setState({ focus: !_this.state.active && focus }); // We only set the focus styling if triggered by keyboard navigation
        };
        _this.handleHover = function (hover) {
            _this.setState({ hover: hover });
        };
        return _this;
    }
    CheckBoxWidget.prototype.componentDidUpdate = function () {
        this.setInputElementsIndeterminateProp();
    };
    CheckBoxWidget.prototype.setInputElementsIndeterminateProp = function () {
        if (this.inputElement) {
            this.inputElement.indeterminate = this.props.indeterminate;
        }
    };
    CheckBoxWidget.prototype.render = function () {
        var styles = getStyles();
        var inputProps = {
            'data-tb-test-id': Declarative_1.testId(this.props.testId, 'CheckBox'),
            checked: this.props.checked,
            disabled: this.props.disabled,
            id: this.props.id,
            name: this.props.name,
            onChange: this.handleFormChange,
            ref: this.handleInputRef,
            style: styles.checkbox,
            type: 'checkbox',
        };
        return (React.createElement(InteractiveDom_1.InteractiveDomWrapper, { handleActive: this.handleActive, handleFocus: this.handleFocus, handleHover: this.handleHover },
            React.createElement(DomWidgets_1.InlineBlock, { className: TypeStyle.classes(FocusIndicators_1.SVGInputFocusIndicatorBase, this.state.focus && 'focus'), style: tslib_1.__assign({}, styles.baseDiv, Declarative_1.conditional(this.props.removeLeftMargin, styles.noLeftMargin)) },
                React.createElement(DomWidgets_1.Img, { src: getCheckBoxIcon(this.props, this.state), style: styles.fakeCheckBox }),
                React.createElement("input", tslib_1.__assign({}, inputProps)))));
    };
    return CheckBoxWidget;
}(DynamicThemeComponent_1.DynamicThemeComponent));
exports.CheckBoxWidget = CheckBoxWidget;
//# sourceMappingURL=CheckBoxWidget.js.map